import React, { PureComponent } from 'react';
import classnames from 'classnames';
import Loader from '../loader/Loader';

export default class Iframe extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };

    this.onLoad = this.onLoad.bind(this);
  }

  onLoad() {
    this.setState(() => ({ loading: false }));
  }

  render() {
    const { src, width = '100%', height = '100%' } = this.props;
    const { loading } = this.state;
    return (
      <div className="resources-wrapper">
        <Loader loaded={loading} />
        <iframe
          src={src}
          onLoad={this.onLoad}
          className={classnames({ hidden: loading })}
          height={height}
          width={width}
          contentEditable="true"
          title="iframe"
          target="_parent"
          frameBorder="0"
          border="0"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/iframe/Iframe.js